import { BACKEND_LOYAL, BACKEND_PRIVATE } from '@/api/base'

type CreateJobResponse = Pick<LX.Job, 'id' | 'slug' | 'moderation_stage'>

type PublishJobResponse = Pick<LX.Job, 'moderation_stage' | 'status'>

export async function createJob(payload: LX.CreateJobPayload) {
  return BACKEND_PRIVATE.post<CreateJobResponse>('/me/simple-jobs/create', { payload })
}

export async function getJob(id: number | string) {
  return BACKEND_LOYAL.get<LX.Job>('/simple-jobs/get', { params: { id } })
}

export async function editJob(id: number, payload: any) {
  return BACKEND_PRIVATE.put<{ slug: LX.Job['slug'] }>('/me/simple-jobs/edit', { id, payload })
}

export async function publishJob(id: number) {
  return BACKEND_PRIVATE.post<PublishJobResponse>(`/me/simple-jobs/publish?id=${id}`)
}

export async function unpublishJob(id: number) {
  return BACKEND_PRIVATE.post(`/me/simple-jobs/unpublish?id=${id}`)
}

export async function removeJob(id: number) {
  return BACKEND_PRIVATE.delete('/me/simple-jobs/remove', { data: { id } })
}

export async function startDispute({ id, params }: { id: number; params: LX.StartDisputeParams }) {
  return BACKEND_PRIVATE.post<{ tx_id: string }>(`/me/jobs/simple/jobs/block?id=${id}`, params)
}

export async function doneJob(id: number) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/jobs/mark-done?id=${id}`)
}

export async function cancelDoneJob(id: number) {
  return BACKEND_PRIVATE.post(`/me/jobs/simple/jobs/mark-not-done?id=${id}`)
}
